import React from "react";
import classNames from "classnames";
import styles from "./SearchFilter.less";
class SearchFilter extends React.Component {
    constructor(props) {
        super(props);
        globalFilterInputContainerHack = this;
    }
    searchChange(event) {
        this.props.changeFilter(this.input.value || " ");
        //if ( event.target.value ) {
        //    this.props.changeFilter( event.target.value );
        //} else {
        //    // HACK: need to always havee something in the search. The custom filterer will remove the space later
        //    this.props.changeFilter( " " );
        //}
    }
    searchChangeHack(text) {
        this.props.changeFilter(text);
    }
    render() {
        return (React.createElement("div", { className: classNames(styles.searchInput, "input-group") },
            React.createElement("input", { ref: (input) => { this.input = input; }, id: "TableSearchFilterHack", type: "text", "aria-describedby": "searchFilterAddon", className: "form-control", name: "search", placeholder: "Filter results by...", onChange: (e) => this.searchChange(e) }),
            React.createElement("span", { className: "input-group-addon fa fa-search", id: "searchFilterAddon" }),
            React.createElement("div", { className: styles.searchResultCount },
                "Results: ",
                this.props.currentResults.length)));
    }
}
SearchFilter.defaultProps = {
    query: ""
};
export { SearchFilter };
